__turbopack_context__.v({
  "actions": "EquitySummaryWidget-module__VXy2uq__actions",
  "deltaRow": "EquitySummaryWidget-module__VXy2uq__deltaRow",
  "fieldLabel": "EquitySummaryWidget-module__VXy2uq__fieldLabel",
  "heroValue": "EquitySummaryWidget-module__VXy2uq__heroValue",
  "layout": "EquitySummaryWidget-module__VXy2uq__layout",
  "primary": "EquitySummaryWidget-module__VXy2uq__primary",
  "sep": "EquitySummaryWidget-module__VXy2uq__sep",
});
